<template>
  <div id="highlight">
    <!-- swiper -->
    <swiper :options="swiperOption">
      <swiper-slide v-for="(slide, i) in slides" :index="i" :key="i">
        <a
          v-bind:href="slide.link"
          target="_blank"
        >
          <div class="imageBox">
            <img :src="slide.image" height="300" width="300" />
            <div class="mask">
              <div class="caption">{{slide.title}}</div>
            </div>
          </div>
        </a>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
      <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
import { getLatestMusic } from "../functions/update-info-function";

import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  data() {
    return {
      slides: [],
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 5,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 5
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 5
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 5
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 5
          }
        }
      }
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  methods: {
    getLatestMusic: async function() {
      this.slides = await getLatestMusic();
    }
  },
  beforeMount: function() {
    this.getLatestMusic();
  }
};
</script>

<style scoped>
#highlight {
  background-color: #0c0c0c;
  padding: 20px 0;
}

.imageBox {
  width: 300px;
  height: 300px;
  overflow: hidden;
  position: relative;
}
.imageBox .caption {
  text-align: center;
  color: #fff;
  padding-top: 150px;
  font-style: oblique;
}

.imageBox .mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.4);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.imageBox:hover .mask {
  opacity: 1;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
</style>
